import React from "react";

const TeamCard = ({ image, name, position }) => {
  return (
    <div className="flex flex-col items-center text-center space-y-2">
      <img
        src={image}
        alt={name}
        className="w-24 h-24 rounded-full object-cover"
      />
      <h3 className="text-lg font-semibold text-gray-900">{name}</h3>
      <p className="text-gray-500 text-sm">{position}</p>
    </div>
  );
};

export default TeamCard;
